import { Event } from '../../types';

function addDropzones(events: Event[]): Event[] {
  const newEvents: Event[] = [];

  function isClientOrActivity(event: Event) {
    return event.category === 'CLIENT' || event.category === 'NON_CLIENT';
  }

  for (let i = 0; i < events.length; i++) {
    const previousObj = events[i - 1];
    const currentObj = events[i];

    const newObj = {
      ...currentObj,
      droppable: previousObj && previousObj.category === 'FREE' ? false : true
    };

    const firstIsClientOrActivity = isClientOrActivity(events[0]);

    if (i === 0 && firstIsClientOrActivity) {
      newEvents.push({
        id: `first-dropzone-${newObj.id}`,
        category: 'DROPZONE',
        droppable: true,
        start: newObj.start
      } as Event);
    }

    newEvents.push(newObj);

    const currentIsClientOrActivity = isClientOrActivity(newObj);

    if (
      currentIsClientOrActivity &&
      (i === events.length - 1 ||
        (events[i + 1].category !== 'FREE' &&
          events[i + 1].category !== 'TRAVELTIME'))
    ) {
      newEvents.push({
        id: `dropzone-${currentObj.id}`,
        category: 'DROPZONE',
        droppable: true,
        start: newObj.end
      } as Event);
    }
  }

  return newEvents;
}

function filterFreeOrTravelByMinimumDuration(
  events: Event[],
  durationInMinutes: number
): Event[] {
  return events.filter(({ category, durationInSeconds }) => {
    const appointmentDuration = durationInSeconds / 60;
    const isTravelTime = category === 'TRAVELTIME';

    if (!isTravelTime) return true;
    return appointmentDuration > durationInMinutes;
  });
}

export const filterAndAddDropzones = (events, durationInMinutes) =>
  addDropzones(filterFreeOrTravelByMinimumDuration(events, durationInMinutes));

export function getStackStyle(amountSelected: number): string {
  if (amountSelected > 3) {
    return `
      4px 4px 0px -1px rgba(255, 255, 255),
      4px 4px rgba(0, 0, 0, 0.12),
      8px 8px 0px -1px rgba(255, 255, 255),
      8px 8px rgba(0, 0, 0, 0.06),
      12px 12px 0px -1px rgba(255, 255, 255),
      12px 12px rgba(0, 0, 0, 0.03)
    `;
  } else if (amountSelected === 3) {
    return `
      4px 4px 0px -1px rgba(255, 255, 255),
      4px 4px rgba(0, 0, 0, 0.12),
      8px 8px 0px -1px rgba(255, 255, 255),
      8px 8px rgba(0, 0, 0, 0.06)
    `;
  } else if (amountSelected === 2) {
    return `
      4px 4px 0px -1px rgba(255, 255, 255),
      4px 4px rgba(0, 0, 0, 0.12)
    `;
  } else {
    return 'none';
  }
}
